import React, {Component, Fragment} from 'react'
import ReactDOM from 'react-dom'
import {connect} from 'react-redux'
import BodyClassName from 'react-body-classname'
import {disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks} from 'body-scroll-lock'
import PropTypes from 'prop-types'
import Font from '@cred/react-font'
import actions from './actions'
import {bindActionCreators} from 'redux'
import {Analytics} from '@cred/react-analytics'
import defaultStyles from './styles.module.scss'

class Modal extends Component {
  static displayName = 'Modal'

  static propTypes = {
    modal: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    title: PropTypes.string,
    dismiss: PropTypes.bool,
    onClose: PropTypes.func,
    withoutPadding: PropTypes.bool,
    hideHeader: PropTypes.bool,
    closeIconStyles: PropTypes.string,
    noOverflow: PropTypes.bool,
    multi: PropTypes.bool,
    blocking: PropTypes.bool
  }

  static defaultProps = {
    onClose: () => {},
    dismiss: false,
    withoutPadding: false,
    hideHeader: false,
    closeIconStyles: '',
    noOverflow: false,
    multi: false,
    blocking: false
  }

  static isActive = ({modal, name}) => !!modal[name]

  static getDerivedStateFromProps(props, state) {
    const isActive = !!Modal.isActive(props)

    if (state.isActive !== isActive) {
      return {isActive, isClosing: !isActive}
    }

    return null
  }

  static frameAnimationTime = 100

  targetRef = React.createRef()
  targetElement = null

  state = {isActive: false}
  analytics = new Analytics(this.props.analytics)

  componentDidMount() {
    this.targetElement = this.targetRef.current
  }

  componentWillUnmount() {
    clearAllBodyScrollLocks()
  }

  render() {
    const {
        children,
        title,
        dismiss,
        withoutPadding,
        hideHeader,
        closeIconStyles,
        noOverflow
      } = this.props,
      styles = this.props.styles || defaultStyles,
      {isActive, isClosing} = this.state,
      closingClassModal = isClosing ? styles.closingModal : ''

    if (!isActive && !isClosing) {
      return false
    }

    return (
      ReactDOM.createPortal(
        <Fragment>
          <BodyClassName className={`${isActive ? styles.modalOpened : ''}`}/>
          <div className={[styles.modalOverlay, 'modal--overlay'].join(' ')}>
            {dismiss &&
            <div className={[styles.dismissOverlay, 'modal--dismiss-overlay'].join(' ')} onClick={this.closeModal}/>
            }
            <div
              onAnimationEnd={this.removeFullscreen}
              ref={this.targetRef}
              className={[styles.modal, closingClassModal, noOverflow ? styles.modalNoOverflow : '', 'modal--main'].join(' ')}
            >
              {!hideHeader &&
              <div className={[styles.header, 'modal--header'].join(' ')}>
                <div className={[styles.title, 'modal--title'].join(' ')}>
                  <Font type="bodySmall" weight="bold">{title}</Font>
                </div>

                {dismiss && (
                  <span onClick={this.closeModal} className={[styles.closeIcon, 'modal--close-icon'].join(' ')}>
                    <i className="cred-icon icon-close"/>
                  </span>
                )}
              </div>
              }
              <div className={[styles.content, withoutPadding ? styles.withoutPadding : '', 'modal--content'].join(' ')}>
                {hideHeader && dismiss &&
                <span
                  onClick={this.closeModal}
                  className={[styles.closeIcon, closeIconStyles, 'modal--icon-close-hidden-header'].join(' ')}
                >
                  <i className="cred-icon icon-close"/>
                </span>
                }
                {children}
              </div>
            </div>
          </div>
        </Fragment>,
        document.getElementById('root')
      )
    )
  }

  closeModal = () => {
    const {actions, name, onClose, multi, blocking} = this.props

    if (!blocking) {
      multi ? actions.closeModalMulti(name) : actions.closeModal(name)
    }
    onClose()
  }

  removeFullscreen = () => {
    this.setState({isClosing: false})
  }

  componentDidUpdate(prevProps) {
    const {name} = this.props

    // Is closing
    if (Modal.isActive(prevProps) && !Modal.isActive(this.props)) {
      enableBodyScroll(this.targetElement)
      this.analytics.event({name, action: 'close'})
    }

    // Is opening
    if (!Modal.isActive(prevProps) && Modal.isActive(this.props)) {
      disableBodyScroll(this.targetElement)
      this.analytics.event({name, action: 'view'})
    }
  }
}

const mapStateToProps = state => ({modal: state.components.modal}),
  mapDispatchToProps = dispatch => ({actions: bindActionCreators(actions, dispatch)})

// Export named class and functions for unit tests
export {Modal as ModalNoHocs, mapStateToProps, mapDispatchToProps}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Modal)
